import { render, staticRenderFns } from "./NotificationTray.vue?vue&type=template&id=56bef1cf&scoped=true&"
import script from "./NotificationTray.vue?vue&type=script&lang=js&"
export * from "./NotificationTray.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTray.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotificationTray.vue?vue&type=style&index=1&id=56bef1cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bef1cf",
  null
  
)

export default component.exports